/*
 * Your idle plants, grouped by recipe and reason (worked out each state
 * by the game's controls): the Production screen's "Idle" list, a click
 * selecting a group on the map.
 */

import { createSignal } from "solid-js";

export interface IdleGroup {
  recipe: string;
  /** Why ("No bauxite", "Station full", "Cut off"). */
  why: string;
  /** Why in full, where the short word isn't enough ("Cut off: nothing on
   *  its rail network has or makes Bauxite"). */
  long?: string;
  /** Not linked by rail to what it needs (the fix is track). */
  link?: "no_track" | "cut_off";
  /** The good it's waiting on, or the one it can't get rid of. */
  good: string | null;
  idle: number;
  /** Plants of the recipe in all. */
  total: number;
  /** Their stations (depot indexes), to select. */
  stations: number[];
  /** Barracks instead (producer indexes), when the row is barracks. */
  producers?: number[];
}

const [idleGroups, setIdleGroups] = createSignal<IdleGroup[]>([]);
export { idleGroups, setIdleGroups };

let selector: (g: IdleGroup) => void = () => {};
export function setIdleSelector(f: (g: IdleGroup) => void): void {
  selector = f;
}
export const selectIdle = (g: IdleGroup) => selector(g);
